import SvgIcon from "../../../../parts/SvgIcon";
import QuestionOptions from "./QuestionCreateOptions";
import { useTranslation } from "react-i18next";
import QuestionMultiple from "./QuestionMultiple";
import QuestionProgressPictures from "./QuestionProgressPictures";
import QuestionScale from "./QuestionScale";
import QuestionShort from "./QuestionShort";

const TEMPLATE_TITLE_TYPES = [
  "bodyweight",
  "nutrition",
  "steps",
  "sleep",
  "hrv",
  "progress",
  "measurement",
];

const getQuestionDisplayTitle = (type, title, t) => {
  if (type && TEMPLATE_TITLE_TYPES.includes(type)) {
    return t(`questionTypeDefaults.${type}Title`);
  }
  return String(title ?? "");
};

const QuestionDisplay = ({
  title,
  type,
  body,
  id,
  onEdit,
  onDelete,
  disableEdit,
  templateDisplay = false,
}) => {
  const { t } = useTranslation("athlete-portal");
  const questionType = getQuestionType(type, body, t);

  return (
    <div className={"questionnaire-question"}>
      <div className="question-header">
        <h4>{getQuestionDisplayTitle(type, title, t)}</h4>
        {/* desktop view */}
        {!templateDisplay && !disableEdit && (
          <QuestionButtonsDisplay
            disableEdit={disableEdit}
            id={id}
            onEdit={onEdit}
            onDelete={onDelete}
            classNames="question-buttons force-mobile-hidden"
          />
        )}
      </div>
      <div className="question-body">{questionType}</div>
      {/* mobile view */}
      {!templateDisplay && !disableEdit && (
        <QuestionButtonsDisplay
          disableEdit={disableEdit}
          id={id}
          onEdit={onEdit}
          onDelete={onDelete}
          classNames="question-buttons force-only-show-mobile"
        />
      )}
    </div>
  );
};

const getQuestionType = (type, body, t = {}) => {
  switch (type) {
    case "short":
    case "bodyweight":
    case "nutrition":
    case "steps":
    case "sleep":
    case "hrv":
    case "bodyFatPercentage":
    case "restingHeartRate":
      return <QuestionShort questionType={type} />;
    case "multiple":
    case "checkbox":
      return <QuestionMultiple type={body?.type} options={body?.options} />;
    case "progress":
      return <QuestionProgressPictures />;
    case "scale":
      return (
        <QuestionScale
          labelLeft={body?.labelLeft}
          labelRight={body?.labelRight}
        />
      );
    case "measurement":
      return <QuestionOptions options={body?.options} />;
    default:
      return <div>{t("questionOptions.errorDisplaying")}</div>;
  }
};

const QuestionButtonsDisplay = ({
  disableEdit,
  id,
  onEdit,
  onDelete,
  classNames,
}) => {
  const { t } = useTranslation("common");
  return (
    <div className={classNames}>
      <button
        data-button-type="secondary"
        data-icon-only
        sz="medium"
        onClick={() => {
          if (!disableEdit) {
            onEdit(id);
          }
        }}
        type="button"
      >
        <SvgIcon src="/img/new-icons/edit-pencil.svg" alt={t("edit")} />
      </button>
      <button
        data-button-type="secondary"
        data-icon-only
        sz="medium"
        onClick={() => {
          if (!disableEdit) {
            onDelete(id);
          }
        }}
        type="button"
      >
        <SvgIcon
          src="/img/new-icons/red-trash.svg"
          alt={t("delete")}
          noFilterOnLight={true}
        />
      </button>
    </div>
  );
};

export default QuestionDisplay;
